export default __webpack_public_path__ + "static/media/little_fren1.8b2ce6a6.gif";